import contains from 'ramda/src/contains'
import { likeStatusEnum } from 'root/src/shared/constants/enums'

export default (userId, { likes, dislikes }) => {
	if (contains(userId, likes)) {
		return likeStatusEnum.LIKED
	} if (contains(userId, dislikes)) {
		return likeStatusEnum.DISLIKED
	}
	return likeStatusEnum.NEUTRAL
}
